export enum slotStatus {
    Enable,
    Disable,
    Closed
}